module.exports = __webpack_public_path__ + "static/media/return-of-the-jedi.83324412.png";